import { render, staticRenderFns } from "./HostingKvmRebuild.vue?vue&type=template&id=b097b18c&scoped=true&"
import script from "./HostingKvmRebuild.vue?vue&type=script&lang=js&"
export * from "./HostingKvmRebuild.vue?vue&type=script&lang=js&"
import style0 from "./HostingKvmRebuild.vue?vue&type=style&index=0&id=b097b18c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b097b18c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b097b18c')) {
      api.createRecord('b097b18c', component.options)
    } else {
      api.reload('b097b18c', component.options)
    }
    module.hot.accept("./HostingKvmRebuild.vue?vue&type=template&id=b097b18c&scoped=true&", function () {
      api.rerender('b097b18c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/HostingKvmRebuild.vue"
export default component.exports